import FreeGridSection from '../components/FreeGridSection';
import SuperchargeSection from '../components/SuperchargeSection';
import CompetitionSection from '../components/CompetitionSection';
import ExclusiveSection from '../components/ExclusiveSection';
import SuperchargeSolarSection from '../components/SuperchargeSolarSection';
import FAQSection from '../components/FAQSection';
import TCSection from '../components/TCSection';
import BannerB from '../components/BannerB';

export default function StatusItem() {
    return (
        <>
            <FreeGridSection />
            <BannerB />
            {/* <BackupSystemSection /> */}
            <SuperchargeSection />
            <CompetitionSection />
            <ExclusiveSection />
            <SuperchargeSolarSection />
            <FAQSection />
            {/* <TCSection /> */}
        </>
    );
}
